/* eslint-disable-next-line camelcase, @typescript-eslint/naming-convention */
import { type GTM, type Cookies } from '@vakantiesnl/types';

export const eventName = (): 'vnl_event' | 'zvr_event' => {
	if (process.env.NEXT_PUBLIC_BRAND == 'VAKNL') return 'vnl_event';
	return 'zvr_event';
};

export const track = (event: GTM.GTMEvent): void => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(event);
};

export const onWindowFullyLoaded = (): GTM.GTMEvent => ({
	event: 'dmp.load',
});

/**
 * clickEvent()
 * Track Click Event in GTM
 *
 * @param {string} source - Location of the clicked item, format: {pagetype}/{element}
 * @param {string} label - Link text
 * @param {string} value - Goal URL
 */
export const clickEvent = (source: string, label: string, value: string): GTM.GTMEvent => {
	return {
		event: 'dmp.click',
		event_value: {
			value_type: 'basic',
			action: 'click',
			source,
			label,
			value,
		},
	};
};

export const trackCookieConsent = (cookieconsent: Cookies.Consent): void => {
	window.dataLayer.push({ event: 'cookie_consent', cookieconsent } as GTM.GTMEvent);
};
